export default "__VITE_ASSET__cZzk8$Te0IxbKasGatFCWg__"